import { MatxLoadable } from "matx";
import { authRoles } from "../../auth/authRoles";

const ViewPostedApplicationSingle = MatxLoadable({
    loader: () =>
        import ("./ViewPostedApplicationSingle")
})
const AllViewPostedApplicationSingle = MatxLoadable({
    loader: () =>
        import ("./AllViewPostedApplicationSingle")
})




// const settings = {
//     activeLayout: "layout1",
//     layout1Settings: {
//         topbar: {
//             show: false
//         },
//         leftSidebar: {
//             show: false,
//             mode: "close"
//         }
//     },
//     layout2Settings: {
//         mode: "full",
//         topbar: {
//             show: false
//         },
//         navbar: { show: false }
//     },
//     secondarySidebar: { show: false },
//     footer: { show: false }
// };

const ViewPostedApplicationSingleRoutes = [
    {
        path: "/view_posted_application_single",
        component: AllViewPostedApplicationSingle,
        // settings
    },

];

export default ViewPostedApplicationSingleRoutes;